import { FieldSet } from './field';
import { ListItem } from './list-item';
import { RelatedEntry } from './related-entry';

export const entityTypes = [
  'appointment',
  'task',
  'note',
  'email',
  'document',
  'interaction',
] as const;

export type EntityType = (typeof entityTypes)[number];

export interface EntityEvent {
  type: EntityType;
  key: string | null;
  with?: RelatedEntry;
  isNew?: boolean;
  isRecurring?: boolean;
  isFollowUp?: boolean;
  isWorkflowActivity?: boolean;
  version?: number;
}

export interface NoteEvent extends EntityEvent {
  autoPaste?: boolean;
}

export interface EntityCount {
  count?: number | null;
}

export interface EntityDetails {
  value: Entity;
  fields: FieldSet;
}

export type Entity = Record<string, unknown>;

export type DisplayEntity = Record<string, string>;

export type EntityLists = Record<string, ListItem<unknown>[]>;

export type EntityListCatalog = Record<string, EntityLists>;
